import { makeStyles } from '@material-ui/core/styles';

// Above sticky AppHeader (1302) so toasts are not covered on mobile
const SNACKBAR_Z_INDEX = 1400;
const MOBILE_SNACKBAR_TOP = 'calc(80px + env(safe-area-inset-top, 0px))';

export const useIAChatWidgetStyles = makeStyles({
  widgetContainer: {
    position: 'relative',
  },
  '@global': {
    '.Snackbar_snackbar-wrapper__ocbPJ': {
      zIndex: `${SNACKBAR_Z_INDEX} !important`,
    },
    '.Snackbar_snackbar-wrapper-top-center__1Gbfi': {
      top: `${MOBILE_SNACKBAR_TOP} !important`,
    },
  },
});

export { MOBILE_SNACKBAR_TOP };
